/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type HexRowOptionsMenuFragment = {
  readonly __typename: "Hex";
  readonly id: c.HexId;
  readonly title: string;
  readonly hexType: Types.HexType;
  readonly projectLanguage: Types.ProjectLanguage;
  readonly canViewLogic: boolean;
  readonly canDelete: boolean;
  readonly canSetOwner: boolean;
  readonly canEdit: boolean;
  readonly canShare: boolean;
  readonly canEditorsShare: boolean;
  readonly archivedDate: c.DateTimeString | null;
  readonly unarchivedDate: c.DateTimeString | null;
  readonly currentDraft: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly title: string;
    readonly logicSessionId: c.AppSessionId;
  };
  readonly lastPublishedVersion: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
  } | null;
  readonly owner: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
  };
};

export type RemoveHexFromCollectionMutationVariables = Types.Exact<{
  collectionId: Types.Scalars["CollectionId"]["input"];
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type RemoveHexFromCollectionMutation = {
  readonly __typename: "Mutation";
  readonly removeProjectFromCollection: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
  };
};

export type SetHexArchivedMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  archived: Types.Scalars["Boolean"]["input"];
}>;

export type SetHexArchivedMutation = {
  readonly __typename: "Mutation";
  readonly setHexArchived: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly archivedDate: c.DateTimeString | null;
  };
};

export const HexRowOptionsMenuFragmentDoc = /*#__PURE__*/ gql`
  fragment HexRowOptionsMenuFragment on Hex {
    id
    title
    hexType
    projectLanguage
    canViewLogic
    canDelete
    canSetOwner
    canEdit
    canShare
    canEditorsShare
    archivedDate
    unarchivedDate
    currentDraft {
      id
      title
      logicSessionId
    }
    lastPublishedVersion {
      id
    }
    owner {
      id
      name
      email
    }
  }
`;
export const RemoveHexFromCollectionDocument = /*#__PURE__*/ gql`
  mutation RemoveHexFromCollection(
    $collectionId: CollectionId!
    $hexId: HexId!
  ) {
    removeProjectFromCollection(collectionId: $collectionId, hexId: $hexId) {
      id
    }
  }
`;
export type RemoveHexFromCollectionMutationFn = Apollo.MutationFunction<
  RemoveHexFromCollectionMutation,
  RemoveHexFromCollectionMutationVariables
>;

/**
 * __useRemoveHexFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveHexFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHexFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHexFromCollectionMutation, { data, loading, error }] = useRemoveHexFromCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useRemoveHexFromCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveHexFromCollectionMutation,
    RemoveHexFromCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveHexFromCollectionMutation,
    RemoveHexFromCollectionMutationVariables
  >(RemoveHexFromCollectionDocument, options);
}
export type RemoveHexFromCollectionMutationHookResult = ReturnType<
  typeof useRemoveHexFromCollectionMutation
>;
export type RemoveHexFromCollectionMutationResult =
  Apollo.MutationResult<RemoveHexFromCollectionMutation>;
export type RemoveHexFromCollectionMutationOptions = Apollo.BaseMutationOptions<
  RemoveHexFromCollectionMutation,
  RemoveHexFromCollectionMutationVariables
>;
export const SetHexArchivedDocument = /*#__PURE__*/ gql`
  mutation SetHexArchived($hexId: HexId!, $archived: Boolean!) {
    setHexArchived(hexId: $hexId, archived: $archived) {
      id
      archivedDate
    }
  }
`;
export type SetHexArchivedMutationFn = Apollo.MutationFunction<
  SetHexArchivedMutation,
  SetHexArchivedMutationVariables
>;

/**
 * __useSetHexArchivedMutation__
 *
 * To run a mutation, you first call `useSetHexArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHexArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHexArchivedMutation, { data, loading, error }] = useSetHexArchivedMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useSetHexArchivedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetHexArchivedMutation,
    SetHexArchivedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetHexArchivedMutation,
    SetHexArchivedMutationVariables
  >(SetHexArchivedDocument, options);
}
export type SetHexArchivedMutationHookResult = ReturnType<
  typeof useSetHexArchivedMutation
>;
export type SetHexArchivedMutationResult =
  Apollo.MutationResult<SetHexArchivedMutation>;
export type SetHexArchivedMutationOptions = Apollo.BaseMutationOptions<
  SetHexArchivedMutation,
  SetHexArchivedMutationVariables
>;
